import React from "react";

class Footer extends React.Component {
  componentWillMount() {
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src =
        "https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js#xfbml=1&version=v2.12&autoLogAppEvents=1";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }

  render() {
    return (
      <div>
        <section className="p-0">
          <div className="container-fluid">
            <div className="bottom-section">
              <div className="row">
                <div className="col-md-6 p-0">
                  {/* <div className="address-bar"> */}
                  <div
                    style={{
                      background: "#fcbe04",
                      paddingTop: 100,
                      paddingBottom: 100,
                      margin: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div>
                      <ul className="footer-style">
                        <li>
                          <div className="footer-icon">
                            <img src="assets/images/locate.png" alt="locate" />
                          </div>
                          <div className="footer-address">
                            <a href={null}>ΑΓΙΟΥ ΒΑΣΙΛΕΙΟΥ 24, ΑΓ. ΔΗΜΗΤΡΙΟΣ</a>
                          </div>
                        </li>
                        <li>
                          <div className="footer-icon">
                            <img
                              src="assets/images/telephone.png"
                              alt="telephone"
                            />
                          </div>
                          <div className="footer-address">
                            <a href="tel:00302114116033">211 411 6033</a>
                            <a href="tel:+306946062545">6946 062 545</a>
                            <a href="tel:+306909443432">6909 443 432</a>
                          </div>
                        </li>
                        <li>
                          <div className="footer-icon">
                            <img
                              src="assets/images/fotter-email.png"
                              alt="fotter-email"
                            />
                          </div>
                          <div className="footer-address">
                            <a href="mailto:info@qrstand.gr">info@qrstand.gr</a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 p-0">
                  <iframe
                    title="google-map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1323.0770379218266!2d23.74050202050015!3d37.93451260649204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a1bd95c0acebcd%3A0x3170221b797c1b7!2sAgiou+Vasiliou+24%2C+Ag.+Dimitrios+173+43!5e0!3m2!1sen!2sgr!4v1558623208623!5m2!1sen!2sgr"
                    allowFullScreen
                    className="md-height"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="copyright-section index-footer">
          <p>
            2021 Copyright &copy; powered by{" "}
            <a
              href="https://progressnet.gr"
              rel="noopener noreferrer"
              target="_blank"
              //style={{ color: "#444444" }}
            >
              <img
                style={{ width: 150, marginBottom: 5, marginLeft: 5 }}
                alt="progressnet-logo"
                src="assets/images/progressnet-logo.png"
              />
            </a>
          </p>
        </div>

        <div className="tap-top">
          <div>
            <i className="fa fa-angle-double-up"></i>
          </div>
        </div>
        {/* <div id="fb-root"></div> */}
        {/*Your customer chat code*/}
        {/* <div className="fb-customerchat"
               page_id="2123438804574660"
               theme_color="#fcbe04"
               logged_in_greeting="Hi! Welcome to PixelStrap Themes  How can we help you?"
               logged_out_greeting="Hi! Welcome to PixelStrap Themes  How can we help you?">
            </div> */}
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js